var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"serverCell"},[_c('div',[_c('div',[_vm._v("预估：¥"+_vm._s(_vm.row.service_estimated_commission))]),_c('div',[_vm._v("实际：¥"+_vm._s(_vm.row.service_real_commission))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }